import React, { useState, useEffect, useRef } from "react";
import { QRCodeSVG } from "qrcode.react";
import * as OTPAuth from "otpauth";

const TOTP_INTERVAL = 30;

const scanLineKeyframes = `
@keyframes scanLine {
  0%, 100% { left: 0; }
  50% { left: calc(100% - 2px); }
}
`;

const RotatingBarcodeContainer = ({ ticketId, totpSecret }) => {
  const [code, setCode] = useState("");
  const totpRef = useRef(null);

  useEffect(() => {
    totpRef.current = new OTPAuth.TOTP({
      algorithm: "SHA1",
      digits: 6,
      period: TOTP_INTERVAL,
      secret: OTPAuth.Secret.fromBase32(totpSecret),
    });

    const update = () => {
      setCode(totpRef.current.generate());
    };

    update();
    const timer = setInterval(update, 1000);
    return () => clearInterval(timer);
  }, [totpSecret]);

  const barcodeValue = `OD1:TKT:R:${ticketId}:${code}`;

  return (
    <div style={{ textAlign: "center" }}>
      <style>{scanLineKeyframes}</style>
      <div
        style={{
          position: "relative",
          display: "inline-block",
          overflow: "hidden",
        }}
      >
        <QRCodeSVG
          value={barcodeValue}
          size={120}
          level="M"
          style={{ display: "block" }}
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "2px",
            height: "100%",
            backgroundColor: "#1982c4",
            opacity: 0.6,
            animation: "scanLine 5s ease-in-out infinite",
            boxShadow: "0 0 4px rgba(25, 130, 196, 0.4)",
          }}
        />
      </div>
      <p
        style={{
          color: "#999",
          fontSize: "9px",
          margin: "6px 0 0 0",
          letterSpacing: "0.3px",
        }}
      >
        Screenshots will not get you in.
      </p>
    </div>
  );
};

export default RotatingBarcodeContainer;
